import { getPrimaryNavigation } from '@/apps'

export default {
  drawerItems: [
    { icon: 'map', label: 'Mapviewer', path: '/mapviewer', subtext: 'GIS viewer' },
    ...getPrimaryNavigation()
  ]
}
